import type { MenuType } from '@/_types/Shared/SiteDatas';
import { Link } from '@inertiajs/react';

import CustomLink from './CusomLink';

type FooterType = {
	name: string;
	copyrightsMenu: MenuType[] | undefined;
	showCopyrightsSpade: boolean;
};

export default function SubFooter(props: FooterType) {
	const { name, copyrightsMenu, showCopyrightsSpade } = props;
	return (
		<div className='minos-grid col-span-full bg-minos-footer-bottomBg py-5'>
			<div className='minos-footer-bottom-font col-start-2 col-end-14 flex flex-wrap items-center justify-center gap-1 text-base tablet:minos-footer-bottom-font'>
				<p className='minos-footer-bottom-font text-base tablet:minos-footer-bottom-font'>
					© Copyright - {name} 2024
				</p>
				<ul className='flex flex-wrap items-center gap-1'>
					{copyrightsMenu?.map((item: MenuType) => {
						return (
							<li key={item.id} className='m-0'>
								· <CustomLink item={item} />
							</li>
						);
					})}
				</ul>
				{showCopyrightsSpade && (
					<>
						<Link
							href='https://www.spade.be/fr/accueil/'
							target='_blank'
							aria-label='Visit Spade website'
							className='inline-flex items-center gap-1'
						>
							· Made by
							<svg
								width='40'
								height='14'
								viewBox='0 0 40 14'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
								aria-hidden='true'
							>
								<path
									fillRule='evenodd'
									clipRule='evenodd'
									className='fill-minos-footer-bottom-color'
									d='M27.5602 2.53498C28.8724 2.53498 29.6296 3.26396 29.8177 3.51323V1.03939L31.8307 0V10.3422H29.9353V9.54262C29.7331 9.806 28.9759 10.535 27.6778 10.535C25.4909 10.535 23.9482 8.903 23.9482 6.54203C23.9482 4.18107 25.3733 2.53498 27.5602 2.53498ZM25.9706 6.55614C25.9706 7.91064 26.7842 8.7572 27.9224 8.7572C29.1452 8.7572 29.8742 7.76484 29.8742 6.55614C29.8742 5.1264 29.0887 4.31276 27.9224 4.31276C26.756 4.31276 25.9706 5.20165 25.9706 6.55614ZM2.15873 4.76421C2.15873 4.38325 2.47854 4.1528 2.94415 4.1528C3.65902 4.1528 4.0823 4.59019 4.31276 4.88178L5.63904 3.88943C5.2769 3.29213 4.47266 2.53493 3.02881 2.53493C1.47208 2.53493 0.263375 3.38149 0.263375 4.79242C0.263375 6.42813 1.57509 6.91158 2.61448 7.29466C3.29649 7.54603 3.86126 7.75418 3.86126 8.21629C3.86126 8.65368 3.49912 8.90295 2.93004 8.90295C2.06937 8.90295 1.56143 8.50789 1.18048 8.0705L0 9.11929C0.409171 9.77303 1.34039 10.5349 2.84068 10.5349C4.48677 10.5349 5.77072 9.60371 5.77072 8.11753C5.77072 6.48451 4.47175 6.04053 3.43177 5.68506C2.73755 5.44778 2.15873 5.24994 2.15873 4.76421ZM10.7043 2.53493C9.4062 2.53493 8.649 3.26391 8.44676 3.52729V2.72776H6.55141V13.0699L8.56434 12.0305V9.55668C8.75247 9.80595 9.50967 10.5349 10.8218 10.5349C13.0088 10.5349 14.4338 8.88884 14.4338 6.52787C14.4338 4.16691 12.8912 2.53493 10.7043 2.53493ZM10.455 8.75715C9.34976 8.75715 8.5032 7.94351 8.5032 6.51377C8.5032 5.30507 9.23218 4.31271 10.455 4.31271C11.5931 4.31271 12.4068 5.15927 12.4068 6.51377C12.4068 7.86826 11.6214 8.75715 10.455 8.75715ZM39.9953 6.59842C39.9953 4.10577 38.6549 2.53493 36.2939 2.53493C34.1211 2.53493 32.5644 4.25627 32.5644 6.55609C32.5644 8.85592 34.1258 10.5349 36.5714 10.5349C38.4668 10.5349 39.4874 9.39678 39.7789 8.86062L38.4527 7.85415C38.2363 8.17397 37.639 8.78537 36.6043 8.78537C35.4803 8.78537 34.6667 8.05639 34.6243 7.03581H39.9859C40 6.89001 40 6.74422 40 6.59842H39.9953ZM34.6761 5.72364C34.7654 4.84886 35.3768 4.18102 36.3222 4.18102C37.2675 4.18102 37.9118 4.79243 37.9541 5.72364H34.6761ZM19.1134 2.53493C19.8894 2.53493 20.6043 2.73246 21.211 3.07108V3.06638V2.72305H23.224V10.3421H21.4462L21.3427 9.95174C20.7125 10.3233 19.9553 10.5349 19.1134 10.5349C16.7384 10.5349 15.017 8.87003 15.017 6.55609C15.017 4.24216 16.7948 2.53493 19.1134 2.53493ZM17.03 6.55609C17.03 7.85415 17.9188 8.75715 19.1134 8.75715C20.3221 8.75715 21.211 7.85415 21.211 6.55609C21.211 5.25803 20.3221 4.31271 19.1134 4.31271C17.9047 4.31271 17.03 5.25803 17.03 6.55609Z'
								/>
							</svg>
						</Link>
					</>
				)}
			</div>
		</div>
	);
}
